import { render, staticRenderFns } from "./notification-list-card.vue?vue&type=template&id=79b86d4e&"
import script from "./notification-list-card.vue?vue&type=script&lang=js&"
export * from "./notification-list-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInfiniteScroll,QSpinnerDots,QCard,QInnerLoading,QSpinnerIos,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInfiniteScroll,QSpinnerDots,QCard,QInnerLoading,QSpinnerIos,QIcon})
